.mf-create-service-case-success__link {
  color: #727272;
}
